exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    background-color: #F0F0F0;\r\n    display: block;\r\n    /* height: 100px; */\r\n}\r\n.move-orders-popup-wrapper {\r\n    position: relative;\r\n}\r\n\r\n.move-orders-popup-wrapper .mve-order-cell {\r\n    padding-bottom: 10px;\r\n    padding-top: 10px;\r\n}\r\n.move-orders-popup-wrapper .mve-order-cell-lbl {\r\n    color: #959595;\r\n    font-size: 13px;\r\n}\r\n.move-orders-popup-wrapper .mve-order-txt-box{\r\n    width: 100%;\r\n    height: 30px;\r\n    border: 1px solid #D9D9D9;\r\n    color: #000000;\r\n    text-align: right;\r\n}\r\n.move-orders-popup-wrapper .mve-order-key{\r\n    text-align: left;\r\n}\r\n.move-orders-summary {\r\n    margin-left: -5px;\r\n    border-bottom: 1px solid #D9D9D9;\r\n}\r\n.move-orders-popup-wrapper .btn-submit {\r\n    padding-left: 20px;\r\n    margin-left: 35px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/move-orders-popup/move-orders-popup.component.css
// module id = ../../../../../src/app/shared/lookup/wave-control-popups/move-orders-popup/move-orders-popup.component.css
// module chunks = main